import axios from 'axios';

import SocioEditar from '../types/SocioEditar';


async function GuardarSocio(prmSocio: SocioEditar) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/guardar_socio"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "socio": {
                "id": prmSocio.id,
                "documento": prmSocio.documento,
                "apellido": prmSocio.apellido,
                "nombres": prmSocio.nombres,
                "fchnac": prmSocio.fchnac,
                "sexo": prmSocio.sexo,
                "tiposocio": prmSocio.tiposocio,
                "email": prmSocio.email,
                "celular": prmSocio.celular,
                "doctitular": prmSocio.doctitular,
                "origen": prmSocio.origen,
                "habilitado": prmSocio.habilitado,
                "agente": prmSocio.agente,
                "idplan": prmSocio.idplan,
                "dadobaja": prmSocio.dadobaja
            }
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default GuardarSocio;